import React, { useEffect } from 'react'
import PageContent from '@components/layout/PageContent'
import { preloadedFlowContainer } from './enroll/finalize/confirmation'
import { Stepper } from '@components/storybook'
import { enrollSteps } from '@utils/steps'
import { Alert, ColorType, Text } from '@clear/design-system'
import { StepTitle } from '@components/layout/Form'

export default function SchedulerPage() {
  useEffect(() => {
    if (preloadedFlowContainer) {
      const schedulerContainer = document.getElementById('lexcontainer')
      schedulerContainer.appendChild(preloadedFlowContainer)
      preloadedFlowContainer.style.display = 'block'
    }
  })
  return (
    <>
      <Stepper current={6} steps={enrollSteps} />
      <PageContent width="800px">
        <StepTitle>
          Book Your Appointment{' '}
          <Text fontSize="18px" className="align-middle" fontWeight={400}>
            (Optional)
          </Text>
        </StepTitle>
        <Text
          as="p"
          className="text-dhs-blue"
          my={5}
          fontSize="18px"
          fontWeight={400}
        >
          Walk-ins are always welcome.
        </Text>
        <Alert
          mb={5}
          defaultIcon
          backgroundColor={'dhsBlue' as ColorType}
          color="neutralsWhite"
          text="Save time and book an appointment"
        />
        <div id="lexcontainer" />
      </PageContent>
    </>
  )
}
